module.exports = __webpack_public_path__ + "dimer/static/img/t$ePageBG1.43fc1cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t$ePageBG1.jpg
// module id = rvDS
// module chunks = 0